import React, {useState, useEffect, Fragment} from 'react'
import {Table, message, Button,} from 'antd';
import {getGnOrders, reqGnOrderReason,} from '../../api'
import {transferDateToValues,} from "../../utills/common";
import {getVehicleInfo} from "../../utills/common";
import LinkButton from "../../components/link-button";
import OrderCancelledModal from "./order-cancelled-modal"

export default function OrderTable(props) {
    //table
    const [dataSource, setDataSource] = useState([]);
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [visible, setVisible] = useState();
    const [order, setOrder] = useState();
    //table
    const columns = [{
        title: '订单编号',
        dataIndex: 'orderNo',
        width: 135,
        render: (text, record) => (
            <a onClick={() => props.history.push('/domesticOrderDetail', {orderId: record.id})}>{text}</a>
        )
    }, {
        title: '起运地',
        dataIndex: 'originProvince',
        render: (text, record) => {
            return record.originProvince + " " + record.originCity;
        }
    }, {
        title: '目的地',
        dataIndex: 'destinationProvince',
        render: (text, record) => {
            return record.destinationProvince + " " + record.destinationCity;
        }
    }]
    // 已下单
    if (props.status === 'commit') {
        columns.push({
            title: '预计提货时间',
            dataIndex: 'deliveryEstimateDt',
        }, {
            title: '车型',
            dataIndex: 'vehicleType',
        }, {
            title: '操作',
            dataIndex: 'opt',
            render: (text, record) => {
                return <span>
                    <LinkButton
                        onClick={() => cancelledOrder(record)}>取消</LinkButton>
                    </span>

            }
        })
    }
    // 审核失败
    if (props.status === 'failed') {
        columns.push({
            title: '预计提货时间',
            dataIndex: 'deliveryEstimateDt',
        }, {
            title: '车型',
            dataIndex: 'vehicleType',
        }, {
            title: '失败备注',
            ellipsis: true,
            dataIndex: 'remark',
        }, {
            title: '操作',
            dataIndex: 'opt',
            render: (text, record) => (
                <Fragment>
                    <a onClick={() => props.history.push('/domesticOrder', {orderId: record.id})}>修改</a>
                    <LinkButton
                        onClick={() => cancelledOrder(record)}>取消</LinkButton>
                </Fragment>
            )
        })
    }
    //已审核
    if (props.status === 'pass') {
        columns.push({
            title: '预计提货时间',
            dataIndex: 'deliveryEstimateDt',
        }, {
            title: '车型',
            dataIndex: 'vehicleType',
        }, {
            title: '车辆',
            dataIndex: 'vehicleNo',
            render: (text, record) => (
                <span>{getVehicleInfo(record.vehicleNo, record.hangNo)}</span>
            )
        })
    }
    //已上门
    if (props.status === 'collect') {
        columns.push({
            title: '预计提货时间',
            dataIndex: 'deliveryEstimateDt',
        }, {
            title: '车型',
            dataIndex: 'vehicleType',
        }, {
            title: '车辆',
            dataIndex: 'vehicleNo',
            render: (text, record) => (
                <span>{getVehicleInfo(record.vehicleNo, record.hangNo)}</span>
            )
        }, {
            title: '提货时间',
            dataIndex: 'collectDt',
        })
    }
    //运输中
    if (props.status === 'send') {
        columns.push({
            title: '车辆',
            dataIndex: 'vehicleNo',
            render: (text, record) => (
                <span>{getVehicleInfo(record.vehicleNo, record.hangNo)}</span>
            )
        }, {
            title: '提货时间',
            dataIndex: 'collectDt',
        }, {
            title: '发运时间',
            dataIndex: 'sendDt',
        }, {
            title: '预计抵达时间',
            dataIndex: 'estimateArriveDt',
        })
    }
    //已抵达
    if (props.status === 'arrive') {
        columns.push({
            title: '车辆',
            dataIndex: 'vehicleNo',
            render: (text, record) => (
                <span>{getVehicleInfo(record.vehicleNo, record.hangNo)}</span>
            )
        }, {
            title: '发运时间',
            dataIndex: 'sendDt',
        }, {
            title: '抵达时间',
            dataIndex: 'arriveDt',
        })
    }
    //已取消
    if (props.status === 'cancelled') {
        columns.push({
            title: '预计提货时间',
            dataIndex: 'deliveryEstimateDt',
        }, {
            title: '车型',
            dataIndex: 'vehicleType',
        })
    }
    //全部
    if (props.status === '') {
        columns.push({
            title: '车型',
            dataIndex: 'vehicleType',
        }, {
            title: '车辆',
            dataIndex: 'vehicleNo',
            render: (text, record) => (
                <span>{getVehicleInfo(record.vehicleNo, record.hangNo)}</span>
            )
        }, {
            title: '预计提货时间',
            dataIndex: 'deliveryEstimateDt',
        }, {
            title: '提货时间',
            dataIndex: 'collectDt',
        }, {
            title: '发运时间',
            dataIndex: 'sendDt',
        }, {
            title: '抵达时间',
            dataIndex: 'arriveDt',
        }, {
            title: '卸货时间',
            dataIndex: 'dischargeDt',
        })
    }

    // 取消订单操作
    const cancelledOrder = (data) => {
        setVisible(true);
        setOrder(data);
    }

    const onOk = data => {
        gnOrderCancelled(data)
        onCancel();
    }
    const gnOrderCancelled = async (data) => {
        const result = await reqGnOrderReason(data);
        if (result.code === 201) {
            message.success(result.message)
            getProducts(pageNum)
        } else {
            message.error(result.message)
        }
    }

    const onCancel = () => {
        setVisible(false);
    }

    //点击查询后表单提交
    const getProducts = async (values, pageNum = 1, pageSize = 10) => {
        const po = {...values, pageNum, pageSize, orderStatus: props.status}
        transferDateToValues(po, ['collectDt', 'sendDt']);
        let result = await getGnOrders(po);
        if (result.code == 200) {
            setPageNum(pageNum);
            setPageSize(pageSize)
            setDataSource(result.data.rows);
            setTotal(result.data.total);
        } else {
            message.error(result.message)
        }
    };
    useEffect(() => {
        getProducts(props.criteria, pageNum, pageSize);
    }, [props.criteria]);
    return <Fragment>
        <Table
            columns={columns}
            bordered
            dataSource={dataSource}
            rowKey='id'
            pagination={{
                current: pageNum,
                total: total,
                showQuickJumper: true,
                onChange: (pageNum) => getProducts(props.criteria, pageNum)
            }}
            size="middle"
        />

        <OrderCancelledModal
            visible={visible}
            order={order}
            onOk={onOk}
            onCancel={onCancel}
        />
    </Fragment>
}